export const FOOTBALL_LOGOS: Record<string, Record<string, string>> = {
  "EPL": {
    "AFC Bournemouth": "epl/afc-bournemouth",
    "Arsenal": "epl/arsenal",
    "Aston Villa": "epl/aston-villa",
    "Brentford": "epl/brentford",
    "Brighton & Hove Albion": "epl/brighton-hove-albion",
    "Chelsea": "epl/chelsea",
    "Coventry City": "epl/coventry-city",
    "Crystal Palace": "epl/crystal-palace",
    "Everton": "epl/everton",
    "Fulham": "epl/fulham",
    "Hull City": "epl/hull-city",
    "Ipswich Town": "epl/ipswich-town",
    "Leeds United": "epl/leeds-united",
    "Liverpool": "epl/liverpool",
    "Manchester City": "epl/manchester-city",
    "Manchester United": "epl/manchester-united",
    "Newcastle United": "epl/newcastle-united",
    "Nottingham Forest": "epl/nottingham-forest",
    "Sunderland": "epl/sunderland",
    "Tottenham Hotspur": "epl/tottenham-hotspur"
  },
  "ELC": {
    "Birmingham City": "elc/birmingham-city",
    "Blackburn Rovers": "elc/blackburn-rovers",
    "Bolton Wanderers": "elc/bolton-wanderers",
    "Bristol City": "elc/bristol-city",
    "Burnley": "elc/burnley",
    "Cardiff City": "elc/cardiff-city",
    "Charlton Athletic": "elc/charlton-athletic",
    "Derby County": "elc/derby-county",
    "Lincoln City": "elc/lincoln-city",
    "Middlesbrough": "elc/middlesbrough",
    "Millwall": "elc/millwall",
    "Norwich City": "elc/norwich-city",
    "Portsmouth": "elc/portsmouth",
    "Preston North End": "elc/preston-north-end",
    "Queens Park Rangers": "elc/queens-park-rangers",
    "Sheffield United": "elc/sheffield-united",
    "Southampton": "elc/southampton",
    "Stoke City": "elc/stoke-city",
    "Swansea City": "elc/swansea-city",
    "Watford": "elc/watford",
    "West Bromwich Albion": "elc/west-bromwich-albion",
    "West Ham United": "elc/west-ham-united",
    "Wolverhampton Wanderers": "elc/wolverhampton-wanderers",
    "Wrexham": "elc/wrexham"
  },
  "LALIGA": {
    "Athletic Club": "laliga/athletic-club",
    "Atlético Madrid": "laliga/atletico-madrid",
    "Barcelona": "laliga/barcelona",
    "Celta Vigo": "laliga/celta-vigo",
    "Deportivo A Coruña": "laliga/deportivo-a-coruna",
    "Deportivo Alavés": "laliga/deportivo-alaves",
    "Elche": "laliga/elche",
    "Espanyol": "laliga/espanyol",
    "Getafe": "laliga/getafe",
    "Levante": "laliga/levante",
    "Málaga": "laliga/malaga",
    "Osasuna": "laliga/osasuna",
    "Racing Santander": "laliga/racing-santander",
    "Rayo Vallecano": "laliga/rayo-vallecano",
    "Real Betis": "laliga/real-betis",
    "Real Madrid": "laliga/real-madrid",
    "Real Sociedad": "laliga/real-sociedad",
    "Sevilla": "laliga/sevilla",
    "Valencia": "laliga/valencia",
    "Villarreal": "laliga/villarreal"
  },
  "SERIEA": {
    "Atalanta": "seriea/atalanta",
    "Bologna": "seriea/bologna",
    "Cagliari": "seriea/cagliari",
    "Como": "seriea/como",
    "Fiorentina": "seriea/fiorentina",
    "Frosinone": "seriea/frosinone",
    "Genoa": "seriea/genoa",
    "Inter": "seriea/inter",
    "Juventus": "seriea/juventus",
    "Lazio": "seriea/lazio",
    "Lecce": "seriea/lecce",
    "Milan": "seriea/milan",
    "Monza": "seriea/monza",
    "Napoli": "seriea/napoli",
    "Parma": "seriea/parma",
    "Roma": "seriea/roma",
    "Sassuolo": "seriea/sassuolo",
    "Torino": "seriea/torino",
    "Udinese": "seriea/udinese",
    "Venezia": "seriea/venezia"
  },
  "BUNDESLIGA": {
    "1. FC Köln": "bundesliga/1-fc-koln",
    "Augsburg": "bundesliga/augsburg",
    "Bayer Leverkusen": "bundesliga/bayer-leverkusen",
    "Bayern München": "bundesliga/bayern-munchen",
    "Borussia Dortmund": "bundesliga/borussia-dortmund",
    "Borussia Mönchengladbach": "bundesliga/borussia-monchengladbach",
    "Eintracht Frankfurt": "bundesliga/eintracht-frankfurt",
    "Elversberg": "bundesliga/elversberg",
    "Freiburg": "bundesliga/freiburg",
    "Hamburger SV": "bundesliga/hamburger-sv",
    "Hoffenheim": "bundesliga/hoffenheim",
    "Mainz 05": "bundesliga/mainz-05",
    "Paderborn": "bundesliga/paderborn",
    "RB Leipzig": "bundesliga/rb-leipzig",
    "Schalke 04": "bundesliga/schalke-04",
    "Union Berlin": "bundesliga/union-berlin",
    "VfB Stuttgart": "bundesliga/vfb-stuttgart",
    "Werder Bremen": "bundesliga/werder-bremen"
  },
  "LIGUE1": {
    "Angers": "ligue1/angers",
    "Auxerre": "ligue1/auxerre",
    "Brest": "ligue1/brest",
    "Le Havre": "ligue1/le-havre",
    "Le Mans": "ligue1/le-mans",
    "Lens": "ligue1/lens",
    "Lille": "ligue1/lille",
    "Lorient": "ligue1/lorient",
    "Lyon": "ligue1/lyon",
    "Marseille": "ligue1/marseille",
    "Monaco": "ligue1/monaco",
    "Nice": "ligue1/nice",
    "Paris FC": "ligue1/paris-fc",
    "Paris Saint-Germain": "ligue1/paris-saint-germain",
    "Rennes": "ligue1/rennes",
    "Strasbourg": "ligue1/strasbourg",
    "Toulouse": "ligue1/toulouse",
    "Troyes": "ligue1/troyes"
  },
  "EREDIVISIE": {
    "ADO Den Haag": "eredivisie/ado-den-haag",
    "AZ Alkmaar": "eredivisie/az-alkmaar",
    "Ajax": "eredivisie/ajax",
    "Cambuur": "eredivisie/cambuur",
    "Excelsior": "eredivisie/excelsior",
    "FC Groningen": "eredivisie/fc-groningen",
    "FC Twente": "eredivisie/fc-twente",
    "FC Utrecht": "eredivisie/fc-utrecht",
    "Feyenoord": "eredivisie/feyenoord",
    "Fortuna Sittard": "eredivisie/fortuna-sittard",
    "Go Ahead Eagles": "eredivisie/go-ahead-eagles",
    "NEC Nijmegen": "eredivisie/nec-nijmegen",
    "PEC Zwolle": "eredivisie/pec-zwolle",
    "PSV Eindhoven": "eredivisie/psv-eindhoven",
    "SC Heerenveen": "eredivisie/sc-heerenveen",
    "Sparta Rotterdam": "eredivisie/sparta-rotterdam",
    "Telstar": "eredivisie/telstar",
    "Willem II": "eredivisie/willem-ii"
  },
  "LIGAPT": {
    "Académico Viseu": "ligapt/academico-viseu",
    "Alverca": "ligapt/alverca",
    "Arouca": "ligapt/arouca",
    "Benfica": "ligapt/benfica",
    "Braga": "ligapt/braga",
    "Casa Pia AC": "ligapt/casa-pia-ac",
    "Estoril": "ligapt/estoril",
    "Estrela da Amadora": "ligapt/estrela-da-amadora",
    "FC Porto": "ligapt/fc-porto",
    "Famalicão": "ligapt/famalicao",
    "Gil Vicente": "ligapt/gil-vicente",
    "Marítimo": "ligapt/maritimo",
    "Moreirense": "ligapt/moreirense",
    "Nacional": "ligapt/nacional",
    "Rio Ave": "ligapt/rio-ave",
    "Santa Clara": "ligapt/santa-clara",
    "Sporting CP": "ligapt/sporting-cp",
    "Vitória de Guimarães": "ligapt/vitoria-de-guimaraes"
  },
  "JPL": {
    "Anderlecht": "jpl/anderlecht",
    "Cercle Brugge": "jpl/cercle-brugge",
    "Club Brugge": "jpl/club-brugge",
    "Genk": "jpl/genk",
    "Gent": "jpl/gent",
    "KV Mechelen": "jpl/kv-mechelen",
    "Kortrijk": "jpl/kortrijk",
    "Lommel": "jpl/lommel",
    "OH Leuven": "jpl/oh-leuven",
    "RAAL La Louvière": "jpl/raal-la-louviere",
    "Royal Antwerp": "jpl/royal-antwerp",
    "SK Beveren": "jpl/sk-beveren",
    "Sporting Charleroi": "jpl/sporting-charleroi",
    "St.Truiden": "jpl/st-truiden",
    "Standard Liège": "jpl/standard-liege",
    "Union St.Gilloise": "jpl/union-st-gilloise",
    "Westerlo": "jpl/westerlo",
    "Zulte Waregem": "jpl/zulte-waregem"
  },
  "SUPERLIG": {
    "Alanyaspor": "superlig/alanyaspor",
    "Amed Sportif": "superlig/amed-sportif",
    "Başakşehir": "superlig/basaksehir",
    "Beşiktaş": "superlig/besiktas",
    "Erzurumspor FK": "superlig/erzurumspor-fk",
    "Eyüpspor": "superlig/eyupspor",
    "Fenerbahçe": "superlig/fenerbahce",
    "Galatasaray": "superlig/galatasaray",
    "Gaziantep FK": "superlig/gaziantep-fk",
    "Gençlerbirliği": "superlig/genclerbirligi",
    "Göztepe": "superlig/goztepe",
    "Kasımpaşa": "superlig/kasmpasa",
    "Kocaelispor": "superlig/kocaelispor",
    "Konyaspor": "superlig/konyaspor",
    "Rizespor": "superlig/rizespor",
    "Samsunspor": "superlig/samsunspor",
    "Trabzonspor": "superlig/trabzonspor",
    "Çorum FK": "superlig/corum-fk"
  },
  "GRSL": {
    "AEK Athens": "grsl/aek-athens",
    "Aris Thessaloniki": "grsl/aris-thessaloniki",
    "Asteras Tripolis": "grsl/asteras-tripolis",
    "Atromitos": "grsl/atromitos",
    "Iraklis": "grsl/iraklis",
    "Kalamata": "grsl/kalamata",
    "Kifisia FC": "grsl/kifisia-fc",
    "Levadiakos": "grsl/levadiakos",
    "NFC Volos": "grsl/nfc-volos",
    "OFI Crete": "grsl/ofi-crete",
    "Olympiacos": "grsl/olympiacos",
    "PAOK Thessaloniki": "grsl/paok-thessaloniki",
    "Panathinaikos": "grsl/panathinaikos",
    "Panetolikos": "grsl/panetolikos"
  },
  "AUTBL": {
    "Altach": "autbl/altach",
    "Austria Lustenau": "autbl/austria-lustenau",
    "Austria Wien": "autbl/austria-wien",
    "Grazer AK": "autbl/grazer-ak",
    "Hartberg": "autbl/hartberg",
    "LASK": "autbl/lask",
    "Rapid Wien": "autbl/rapid-wien",
    "Ried": "autbl/ried",
    "Salzburg": "autbl/salzburg",
    "Sturm Graz": "autbl/sturm-graz",
    "WSG Tirol": "autbl/wsg-tirol",
    "Wolfsberger AC": "autbl/wolfsberger-ac"
  },
  "SUISL": {
    "Basel": "suisl/basel",
    "FC Vaduz": "suisl/fc-vaduz",
    "FC Zürich": "suisl/fc-zurich",
    "Grasshopper": "suisl/grasshopper",
    "Lausanne": "suisl/lausanne",
    "Lugano": "suisl/lugano",
    "Luzern": "suisl/luzern",
    "Servette": "suisl/servette",
    "Sion": "suisl/sion",
    "St. Gallen": "suisl/st-gallen",
    "Thun": "suisl/thun",
    "Young Boys": "suisl/young-boys"
  },
  "SPFL": {
    "Aberdeen": "spfl/aberdeen",
    "Celtic": "spfl/celtic",
    "Dundee FC": "spfl/dundee-fc",
    "Dundee United": "spfl/dundee-united",
    "Falkirk": "spfl/falkirk",
    "Heart of Midlothian": "spfl/heart-of-midlothian",
    "Hibernian": "spfl/hibernian",
    "Kilmarnock": "spfl/kilmarnock",
    "Motherwell": "spfl/motherwell",
    "Rangers": "spfl/rangers",
    "St. Johnstone": "spfl/st-johnstone",
    "St. Mirren": "spfl/st-mirren"
  },
  "HNL": {
    "Dinamo Zagreb": "hnl/dinamo-zagreb",
    "HNK Gorica": "hnl/hnk-gorica",
    "Hajduk Split": "hnl/hajduk-split",
    "NK Istra 1961": "hnl/nk-istra-1961",
    "NK Lokomotiva": "hnl/nk-lokomotiva",
    "NK Varaždin": "hnl/nk-varazdin",
    "Osijek": "hnl/osijek",
    "Rijeka": "hnl/rijeka",
    "Rudeš": "hnl/rudes",
    "Slaven": "hnl/slaven"
  },
  "BULFPL": {
    "Arda Kardzhali": "bulfpl/arda-kardzhali",
    "Botev Plovdiv": "bulfpl/botev-plovdiv",
    "Botev Vratsa": "bulfpl/botev-vratsa",
    "CSKA 1948": "bulfpl/cska-1948",
    "CSKA Sofia": "bulfpl/cska-sofia",
    "Cherno More Varna": "bulfpl/cherno-more-varna",
    "Dunav Ruse": "bulfpl/dunav-ruse",
    "Levski Sofia": "bulfpl/levski-sofia",
    "Lokomotiv Plovdiv": "bulfpl/lokomotiv-plovdiv",
    "Ludogorets Razgrad": "bulfpl/ludogorets-razgrad",
    "PFC Lokomotiv Sofia 1929": "bulfpl/pfc-lokomotiv-sofia-1929",
    "Septemvri Sofia": "bulfpl/septemvri-sofia",
    "Slavia Sofia": "bulfpl/slavia-sofia",
    "Spartak Varna": "bulfpl/spartak-varna"
  },
  "ROUL1": {
    "Botoșani": "roul1/botosani",
    "CFR Cluj": "roul1/cfr-cluj",
    "Corvinul Hunedoara": "roul1/corvinul-hunedoara",
    "Csikszereda Miercurea Ciuc": "roul1/csikszereda-miercurea-ciuc",
    "Dinamo București": "roul1/dinamo-bucuresti",
    "FC Argeș Pitesti": "roul1/fc-arges-pitesti",
    "FC Voluntari": "roul1/fc-voluntari",
    "FCSB": "roul1/fcsb",
    "FCV Farul Constanța": "roul1/fcv-farul-constanta",
    "Oțelul Galați": "roul1/otelul-galati",
    "Petrolul Ploiești": "roul1/petrolul-ploiesti",
    "Rapid București": "roul1/rapid-bucuresti",
    "Sepsi OSK": "roul1/sepsi-osk",
    "UTA Arad": "roul1/uta-arad",
    "Universitatea Cluj": "roul1/universitatea-cluj",
    "Universitatea Craiova": "roul1/universitatea-craiova"
  },
  "EGYPL": {
    "Abo Qir Semad": "egypl/abo-qir-semad",
    "Al Ahly SC": "egypl/al-ahly-sc",
    "Al Ittihad Alexandria": "egypl/al-ittihad-alexandria",
    "Al Masry SC": "egypl/al-masry-sc",
    "Al Mokawloon Al Arab": "egypl/al-mokawloon-al-arab",
    "Al Sharkeyah-ENPPI": "egypl/al-sharkeyah-enppi",
    "Asyut Petroleum": "egypl/asyut-petroleum",
    "Ceramica Cleopatra": "egypl/ceramica-cleopatra",
    "El Gouna FC": "egypl/el-gouna-fc",
    "Ghazl Al Mahalla": "egypl/ghazl-al-mahalla",
    "Modern Sport FC": "egypl/modern-sport-fc",
    "National Bank": "egypl/national-bank",
    "Olympic El Qanah FC": "egypl/olympic-el-qanah-fc",
    "Petrojet-Suez": "egypl/petrojet-suez",
    "Pyramids FC": "egypl/pyramids-fc",
    "Smouha SC": "egypl/smouha-sc",
    "Tala'ea El Gaish": "egypl/tala-ea-el-gaish",
    "Wadi Degla FC": "egypl/wadi-degla-fc",
    "ZED FC": "egypl/zed-fc",
    "Zamalek SC": "egypl/zamalek-sc"
  },
  "UAEPL": {
    "Ajman": "uaepl/ajman",
    "Al-Ain": "uaepl/al-ain",
    "Al-Dhafra": "uaepl/al-dhafra",
    "Al-Jazira": "uaepl/al-jazira",
    "Al-Nasr SC": "uaepl/al-nasr-sc",
    "Al-Wahda": "uaepl/al-wahda",
    "Al-Wasl": "uaepl/al-wasl",
    "Baniyas": "uaepl/baniyas",
    "Hatta": "uaepl/hatta",
    "Kalba FC": "uaepl/kalba-fc",
    "Khorfakkan": "uaepl/khorfakkan",
    "Shabab Al-Ahli Dubai FC": "uaepl/shabab-al-ahli-dubai-fc",
    "Sharjah Cultural Club": "uaepl/sharjah-cultural-club",
    "United FC": "uaepl/united-fc"
  },
  "ALLSV": {
    "AIK": "allsv/aik",
    "Brommapojkarna": "allsv/brommapojkarna",
    "Degerfors": "allsv/degerfors",
    "Djurgården": "allsv/djurgarden",
    "Elfsborg": "allsv/elfsborg",
    "GAIS": "allsv/gais",
    "Halmstads BK": "allsv/halmstads-bk",
    "Hammarby": "allsv/hammarby",
    "Häcken": "allsv/hacken",
    "IFK Göteborg": "allsv/ifk-goteborg",
    "Kalmar FF": "allsv/kalmar-ff",
    "Malmö FF": "allsv/malmo-ff",
    "Mjällby": "allsv/mjallby",
    "Sirius": "allsv/sirius",
    "Västerås SK": "allsv/vasteras-sk",
    "Örgryte": "allsv/orgryte"
  },
  "ELITE": {
    "Aalesund": "elite/aalesund",
    "Bodø/Glimt": "elite/bod-glimt",
    "Brann": "elite/brann",
    "Fredrikstad": "elite/fredrikstad",
    "Hamarkameratene": "elite/hamarkameratene",
    "KFUM": "elite/kfum",
    "Kristiansund": "elite/kristiansund",
    "Lillestrøm": "elite/lillestrm",
    "Molde": "elite/molde",
    "Rosenborg": "elite/rosenborg",
    "Sandefjord": "elite/sandefjord",
    "Sarpsborg 08": "elite/sarpsborg-08",
    "Start": "elite/start",
    "Tromsø": "elite/troms",
    "Viking": "elite/viking",
    "Vålerenga": "elite/valerenga"
  },
  "BESTA": {
    "Breiðablik": "besta/breiablik",
    "FH Hafnarfjörður": "besta/fh-hafnarfjorur",
    "Fram Reykjavík": "besta/fram-reykjavik",
    "KA Akureyri": "besta/ka-akureyri",
    "KR Reykjavík": "besta/kr-reykjavik",
    "Keflavík": "besta/keflavik",
    "Stjarnan": "besta/stjarnan",
    "Thór Akureyri": "besta/thor-akureyri",
    "Valur": "besta/valur",
    "Víkingur Reykjavík": "besta/vikingur-reykjavik",
    "ÍA Akranes": "besta/ia-akranes",
    "ÍBV Vestmannaeyjar": "besta/ibv-vestmannaeyjar"
  },
  "CHIPD": {
    "Audax Italiano": "chipd/audax-italiano",
    "Cobresal": "chipd/cobresal",
    "Colo Colo": "chipd/colo-colo",
    "Coquimbo Unido": "chipd/coquimbo-unido",
    "Deportes Concepción": "chipd/deportes-concepcion",
    "Deportes Limache": "chipd/deportes-limache",
    "Everton CD": "chipd/everton-cd",
    "Huachipato": "chipd/huachipato",
    "La Serena": "chipd/la-serena",
    "O'Higgins": "chipd/o-higgins",
    "Palestino": "chipd/palestino",
    "Universidad Católica": "chipd/universidad-catolica",
    "Universidad de Chile": "chipd/universidad-de-chile",
    "Universidad de Concepción": "chipd/universidad-de-concepcion",
    "Unión La Calera": "chipd/union-la-calera",
    "Ñublense": "chipd/nublense"
  }
};
